// 工具栏样式
export default class ToolBarStyle {
    display = 'flex'
    alignItems = "center"
    justifyContent = 'center'
    width = '200px'
    height = '40px'
    lineHeight = 1
    position = 'absolute'
    left = ''
    bottom = ''
    zIndex = 101
    transform = ''
    top = '-40px';
    left = '-50px';
}
